import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";

// V2: PATCH /api/v2/student/profile - identity comes only from the JWT, no userId in the URL.
// profileData must contain the FULL current profile field set (bio + all social links), since
// the V2 endpoint updates both categories together - callers must not send a partial object.
export const PostUserProfileDetails = async (profileData) => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.patch(
			`${CONFIG.STUDENTURL}/api/v2/student/profile`,
			profileData,
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		console.log(error);
		return [];
	}
};
